import { render, staticRenderFns } from "./display_items.vue?vue&type=template&id=3aabfee2&scoped=true"
import script from "./display_items.vue?vue&type=script&lang=js"
export * from "./display_items.vue?vue&type=script&lang=js"
import style0 from "./display_items.vue?vue&type=style&index=0&id=3aabfee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aabfee2",
  null
  
)

export default component.exports